import React, { useState, useEffect, useMemo } from 'react';

import { Typography, Box } from '@mui/material';

import useMeasure from 'react-use-measure';
import { useTransition, a } from '@react-spring/web'
import shuffle from 'lodash.shuffle';

import useMedia from './useMedia';
import data from './data'
import styles from '../../../styles.module.css';

import img_01 from '../../../data/icons/photo.png';


type Props = {}


    const Masonry = () => {
        // Hook1: Tie media queries to the number of columns
        const columns = useMedia(['(min-width: 1500px)', '(min-width: 1000px)', '(min-width: 600px)'], [5, 4, 3], 2)
        // Hook2: Measure the width of the container element
        const [ref, { width }] = useMeasure()
        // Hook3: Hold items
        const [items, set] = useState(data)
        // Hook4: shuffle data every 2 seconds
        useEffect(() => {
            const t = setInterval(() => set(shuffle), 3000)
            return () => clearInterval(t)
        }, [])
        // Hook5: Form a grid of stacked items using width & columns we got from hooks 1 & 2
        const [heights, gridItems] = useMemo(() => {
            let heights = new Array(columns).fill(0) // Each column gets a height starting with zero
            let gridItems = items.map((child, i) => {
                const column = heights.indexOf(Math.min(...heights)) // Basic masonry-grid placing, puts tile into the smallest column using Math.min
                const x = (width / columns) * column // x = container width / number of columns * column index,
                const y = (heights[column] += child.height / 2) - child.height / 2 // y = it's just the height of the current column
                return { ...child, x, y, width: width / columns, height: child.height / 2 }
            })
            return [heights, gridItems]
        }, [columns, items, width])
        // Hook6: Turn the static grid values into animated transitions, any addition, removal or change will be animated
        const transitions = useTransition(gridItems, {
            key: (item: { css: string; height: number }) => item.css,
            from: ({ x, y, width, height }) => ({ x, y, width, height, opacity: 0 }),
            enter: ({ x, y, width, height }) => ({ x, y, width, height, opacity: 1 }),
            update: ({ x, y, width, height }) => ({ x, y, width, height }),
            leave: { height: 0, opacity: 0 },
            config: { mass: 5, tension: 500, friction: 100 },
            trail: 25,
        })
        // Render the grid
        return (
            <>
            <Box sx={{ width: '100%' }}>
                <Box>
                <Typography sx={{ textAlign: 'center' }}>
                    <img src={img_01} width={100} />
                </Typography>
                    <Typography
                                sx={{
                                textTransform: 'uppercase',
                                fontWeight: '600',
                                }}
                                gutterBottom
                                color={'primary.main'}
                                align={'center'}
                            >
                                Photo Gallery
                            </Typography>
                            <Typography
                                variant={'h4'}
                                gutterBottom
                                align={'center'}
                                sx={{ 
                                    fontWeight: 700,
                                    '@media (max-width: 1300px)': {
                                        fontSize: '1.5em'
                                    } 
                                }}
                            >
                                연세 FC 소식
                        </Typography>
                </Box>
                <div ref={ref} className={styles.list} style={{ height: Math.max(...heights) }}>
                    {transitions((style, item) => (
                    <a.div style={style}>
                        <div style={{ backgroundImage: `url(${item.css}?auto=compress&dpr=2&h=500&w=500)`, borderRadius: '15px', boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 20px', }} />
                    </a.div>
                    ))}
                </div>
            </Box>
            </>
        )
    }
    
const PhotoAnimation = (props: Props) => {

    
    return (
        <>
            <Masonry />
        </>
    )
}

export default PhotoAnimation